import type { IconJVSProps } from '@mairistem/composants';
import { UserRole } from '@mairistem/finances-utils';
import type Simulation from '../../interfaces/simulation/simulation';

class BaseOutil {
	code: string;

	icon: IconJVSProps;

	title: string = '';

	isEnabled(userRole: UserRole, _simulation: Simulation) {
		return userRole > UserRole.GESTIONNAIRE;
	}

	renderModal(
		_simulation: Simulation,
		_onClose: () => void,
		_onValidate: () => void,
		_open: boolean,
	) {
		return null;
	}
}

export default BaseOutil;
